
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/rewards",
      function () {
        return require("private-next-pages/account/rewards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/rewards"])
      });
    }
  